import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { API_BASE_URL } from '../config/api';
import { getBanners, getServices, getTestimonials, getCollaborators, getCMSContent ,getLiveGallery } from "../services/apiService";

const Home = () => {
  const mainSlider = useRef(null);
  const thumbSlider = useRef(null);
  const [progress, setProgress] = useState(0);
  const sliderRef = useRef(null);
  const testimonialSliderRef = useRef(null);
  

  // State for dynamic content
  const [banners, setBanners] = useState([]);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [cmsContent, setCmsContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [liveGallery, setLiveGallery] = useState([]);

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [bannersData, servicesData, testimonialsData, collaboratorsData, cmsData,liveGalleryData] = await Promise.all([
          getBanners(),
          getServices(),
          getTestimonials(),
          getCollaborators(),
          getCMSContent('home_page'),
              getLiveGallery(),
        ]);

        setBanners(bannersData?.data || []);
        setServices(servicesData?.data || []);
        setTestimonials(testimonialsData?.data || []);
        setCollaborators(collaboratorsData?.data || []);
        setLiveGallery(liveGalleryData?.data || []);


 

        // Organize CMS content by page_section
        const contentBySection = {};
        (cmsData?.data || []).forEach(item => {
          contentBySection[item.page_section] = item;
        });
        setCmsContent(contentBySection);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const mainSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      speed: 800,
      asNavFor: thumbSlider.current,
      adaptiveHeight: false,
      afterChange: (index) => {
      setCurrentSlide(index); 
      setProgress(Math.round(((index + 1) / (banners.length || 1)) * 100));
    },
  
  };

  const thumbSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    speed: 800,
    asNavFor: mainSlider.current,
    adaptiveHeight: false,
  };


    const serviceSlider = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1100,settings:{ slidesToShow: 2 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } }
    ]
  };

  // const testimonialSlider = {
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     { breakpoint: 1370, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  //     { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  //     { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1 } }
  //   ]
  // };
   const activeTestimonials = testimonials.filter(
  (t) => t.is_active === 1 || t.is_active === true || t.is_active === "1"
);
const count = activeTestimonials.length;


    const testimonialSlider = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1100, settings: { slidesToShow: 2 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } }
    ]
  };

// const testimonialSlider = {
//   dots: false,
//   arrows: false,
//   infinite: count > 3,
//   speed: 400,
//   slidesToShow: Math.min(3, count),  // max 3 on desktop
//   slidesToScroll: 1,
//   rows: 1,                           // force single row
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: Math.min(2, count),
//         slidesToScroll: 1,
//         infinite: count > 2,
//       },
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: count > 1,
//       },
//     },
//   ],
// };
const activeLiveGallery = liveGallery.filter(
  (img) => img.status === true || img.status === "true" || img.status === 1 || img.status === "1"
);

const liveGallerySlider = {
  dots: false,
  arrows: true,
  infinite: activeLiveGallery.length > 4,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 3 } },
    { breakpoint: 900, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
};

useEffect(() => {
  Fancybox.bind("[data-fancybox='livegallery']", { Thumbs: false });
  return () => Fancybox.destroy();
}, [liveGallery]);


const prevSlide = () => mainSlider.current.slickPrev();
const nextSlide = () => mainSlider.current.slickNext();
const [currentSlide, setCurrentSlide] = useState(0); 

  return (
    <>
      <section className="main_slider">
        <Slider {...mainSettings} ref={mainSlider} className="bannerBgSlider">
          {loading ? (
            <div>
              <div className="banner-bg-slider-img">
                <img
                  src="images/banner1.webp"
                  alt="Loading..."
                  width="1920"
                  height="1080"
                />
              </div>
            </div>
          ) : banners.length > 0 ? (
            banners.map((banner, index) => (
              <div key={banner._id || index}>
                <div className="banner-bg-slider-img">
                  <img
                    src={banner.image_path ? `${API_BASE_URL}${banner.image_path}` : "images/banner1.webp"}
                    alt={banner.title || `Banner ${index + 1}`}
                    width="1920"
                    height="1080"
                  />
                </div>
              </div>
            ))
          ) : (
            <div>
              <div className="banner-bg-slider-img">
                <img
                  src="images/banner1.webp"
                  alt="Default Banner"
                  width="1920"
                  height="1080"
                />
              </div>
            </div>
          )}
        </Slider>

        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-sm-4 align-self-center">
      <div className="banner_text">
  <h1>
    <span>
      {banners.length > 0 && banners[currentSlide]?.title ? (
        <>
          {banners[currentSlide].title.split(' ').slice(0, 3).join(' ')}
          <br />
          {banners[currentSlide].title.split(' ').slice(3).join(' ')}
        </>
      ) : null}
    </span>
  </h1>
</div>
            </div>

            <div className="col-lg-6 col-md-4 col-sm-12 p-0 align-self-center">
              <div className="banner_img-prev">
                <Slider {...thumbSettings} ref={thumbSlider} className="bannerSmallSlider">
                  {loading ? (
                    <div>
                      <div className="banner-small-slider-img">
                        <img
                          src="images/banner1.webp"
                          alt="Loading..."
                          width="400"
                          height="225"
                        />
                      </div>
                    </div>
                  ) : banners.length > 0 ? (
                    banners.map((banner, index) => (
                      <div key={banner._id || index}>
                        <div className="banner-small-slider-img">
                          <img
                            src={banner.image_path ? `${API_BASE_URL}${banner.image_path}` : "images/banner1.webp"}
                            alt={banner.title || `Thumbnail ${index + 1}`}
                            width="400"
                            height="225"
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <div className="banner-small-slider-img">
                        <img
                          src="images/banner1.webp"
                          alt="Default Thumbnail"
                          width="400"
                          height="225"
                        />
                      </div>
                    </div>
                  )}
                </Slider>
                <div className="banner-slider-conterl">
                  <div className="custom-flex">
               <div className="banner-silder-text">
                                <h6>Next up</h6>
                                <h5>
                                  {banners.length > 0 && banners[currentSlide]?.sub_title
                                    ? banners[currentSlide].sub_title
                                    : ""}
                                </h5>
                              </div>
                    <div className="banner-slider-btn">
                      <button onClick={prevSlide} className="slider-prev">
                        <i className="fa-solid fa-caret-left"></i>
                      </button>
                      <button onClick={nextSlide} className="slider-next">
                        <i className="fa-solid fa-caret-right"></i>
                      </button>
                    </div>
                  </div>

                  <div className="nike-zoom-progress-barchg">
                    <div
                      className="progress"
                      role="progressbar"
                      aria-valuemin={0}
                      aria-valuemax={100}
                      aria-valuenow={progress}
                      style={{ backgroundSize: `${progress}% 100%` }}
                    >
                      <span className="slider__label sr-only">{progress}% completed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="new-collaborator-sec">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="section-heading">
                <h2>
                  {cmsContent.curated_collaborators?.title || ""}
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            {loading ? (
              <div className="col-12 text-center">
                <p>Loading collaborators...</p>
              </div>
            ) : collaborators.length > 0 ? (
              collaborators.map((collaborator, index) => (
                <div className="col-lg-3" key={collaborator._id || index}>
                  <div className="collab-box">
                    <div className="collab-image">
                      <img
                        src={collaborator.image_path ? `${API_BASE_URL}${collaborator.image_path}` : ""}
                        alt={collaborator.title || "Collaborator"}
                      />
                    </div>
                    <div className="collab-text">
                      <Link to={collaborator.website_link || "#"}>{collaborator.title || "Collaborator"}</Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p>No collaborators available</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="about-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
              <div className="about-img">
                <img
                  src={cmsContent.about_us?.image ? `${API_BASE_URL}/uploads/cms/${cmsContent.about_us.image}` : ""}
                  alt={cmsContent.about_us?.title || ""}
                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12">
              <div className="about-text">
                <h2>{cmsContent.about_us?.subtitle || ""}</h2>
                <ul>
                  {cmsContent.about_us?.title && (
                    <li>
                      <h5>{cmsContent.about_us.title}</h5>
                    </li>
                  )}
                  <li>
                    {cmsContent.about_us?.description ? (
                      <div dangerouslySetInnerHTML={{ __html: cmsContent.about_us.description }} />
                    ) : (
                      <>
     
                      </>
                    )}
                    <Link to="/about" className="theme-btn-1"><span>Enquire Now</span></Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bespoke-sec" >
        <div className="bespoke-bg-img" style={{ backgroundImage: cmsContent.signature_style?.image ? `url(${API_BASE_URL}/uploads/cms/${cmsContent.signature_style.image})` : '' }}>
          <div className="bespoke-content">
            <h2 className="bespoke-title">
              <span className="title-top">{cmsContent.signature_style?.title?.split(' ').slice(0, 1).join(' ') || ""} </span>
              <span className="title-bottom"><h2>{cmsContent.signature_style?.title?.split(' ').slice(1).join(' ') || ""} </h2></span>
            </h2>
          </div>
        </div>
      </section>

      <section className="service-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-12">
              <div className="service-heading">
                <h2>{cmsContent.our_signature_approach?.title || ""}</h2>
                <div className="serviceSlider-btn">
                  <button
                    className="service-btn"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    <i className="fa-solid fa-caret-left"></i>
                  </button>
                  <button
                    className="service-btn"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    <i className="fa-solid fa-caret-right"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12">
              <Slider ref={serviceSlider} {...serviceSlider} className="serviceSlider">
                {loading ? (
                  <div>
                    <div className="service-box">
                      <div className="service-text">
                        <h5>Loading...</h5>
                        <h4>Loading Services</h4>
                        <p>Please wait while we load our services.</p>
                      </div>
                    </div>
                  </div>
                ) : services.length > 0 ? (
                  services.map((service, index) => (
                    <div key={service._id || index}>
                      <div className="service-box">
                        <div className="service-text">
                          <h5>{String(index + 1).padStart(2, '0')}</h5>
                          <h4>{service.title || "Service"}</h4>
                          <p>
                            {service.short_description  || "No description available"}
                          </p>
                          <Link
                            to={`/service-detail/${service.slug || service._id}`}
                            className="theme-btn-1"
                          >
                            <span>More Detail</span>
                          </Link>
                        </div>
                        <div className="service-img">
                          <img
                            src={service.image_path ? `${API_BASE_URL}${service.image_path}` : "images/service-img-1175277391991.png"}
                            alt={service.title || "Service"}
                          />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <div className="service-box">
                      <div className="service-text">
                        <h5>00</h5>
                        <h4>No Services Available</h4>
                        <p>Currently, there are no services to display.</p>
                      </div>
                    </div>
                  </div>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="why-choose-text">
                <h2>{cmsContent.what_sets_us_apart?.title || ""}</h2>

                <p> {cmsContent.what_sets_us_apart?.subtitle || ""} </p>
                {cmsContent.what_sets_us_apart?.description ? (
                  <div dangerouslySetInnerHTML={{ __html: cmsContent.what_sets_us_apart.description }} />
                ) : (
                  <>
                    {/* <p>At The Design Showroom, we deliver curated luxury through world-class interiors and personalized design support. Our West London showroom features exclusive brands like Momenti, JR Stone, Top Ciment, and 1810 Sinks—offering bespoke kitchens, refined finishes, and premium surfaces all in one space.</p>
                    <ul>
                      <li>
                        <p>We work closely with clients and professionals to transform concepts into beautifully executed spaces, combining quality, innovation, and tailored service at every step.</p>
                        <p><img alt="img" src="images/why-choose-icon.png" /> One-Stop Destination for Luxury Interiors &amp; Exteriors</p>
                        <p><img alt="img" src="images/why-choose-icon.png" /> Fully Customized Solutions to Reflect Your Lifestyle</p>
                        <p><img alt="img" src="images/why-choose-icon.png" /> Trusted by Architects, Designers &amp; Property Developers</p>
                        <p><img alt="img" src="images/why-choose-icon.png" /> Premium Access to Globally Celebrated Design Brands</p>
                      </li>
                    </ul> */}
                  </>
                )}
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="why-choose-img">
                <img
                  src={cmsContent.what_sets_us_apart?.image ? `${API_BASE_URL}/uploads/cms/${cmsContent.what_sets_us_apart.image}` : ""}
                  alt={cmsContent.what_sets_us_apart?.title || ""}
                />
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="live-gallery-sec">
  <div className="container-fluid add-padding">
    <div className="row">
      <div className="col-12">
        <div className="section-heading">
          <h2>Live Gallery</h2>
        </div>
      </div>

      <div className="col-12">
        {loading ? (
          <div className="text-center py-5">
            <p>Loading live gallery...</p>
          </div>
        ) : liveGallery.length === 0 ? (
          <div className="text-center py-5">
            <p>No images available.</p>
          </div>
        ) : (
          <Slider {...liveGallerySlider} className="liveGallerySlider">
            {liveGallery
              .filter((img) => img.status === true)
              .map((img, index) => {
                const full = `${API_BASE_URL}${img.image_path}`;
                const thumb = img.thumbnail_path
                  ? `${API_BASE_URL}${img.thumbnail_path}`
                  : full;

                return (
                  <div key={img._id || index}>
                    <div className="project-img-box">
                      <a
                        href={full}
                        data-fancybox="livegallery"
                        data-caption={`Live Gallery Image ${index + 1}`}
                        style={{ width: "100%" }}
                      >
                        <img
                          src={thumb}
                          alt={`Live Gallery ${index + 1}`}
                          className="img-fluid"
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                  </div>
                );
              })}
          </Slider>
        )}
      </div>

      <div className="col-12 text-center mt-2 mb-4">
        <Link to="/livegallery" className="theme-btn-1">
          <span>View Full Gallery</span>
        </Link>
      </div>
    </div>
  </div>
</section>



<section className="testimonial_sec">
  <div className="container-fluid add-padding">
    <div className="row">
      <div className="col-12">
        <div className="section-heading">
          <h2>{cmsContent.words_from_inspired?.title || ""}</h2>
        </div>
      </div>
    </div>

    <div className="container-fluid add-padding">
      {/* LOADING STATE */}
      {loading ? (
        <div className="testimonial_box text-center">
          <i className="fa-solid fa-quote-left"></i>
          <div className="rate">
            <span className="fa fa-star checked"></span>
            <span className="fa fa-star checked"></span>
            <span className="fa fa-star checked"></span>
            <span className="fa fa-star checked"></span>
            <span className="fa fa-star checked testimonial_boxspan"></span>
          </div>
          <p>Loading testimonials...</p>
          <div className="profile">
            {/* <img src="images/testimonial_slider-img-1.png" alt="Loading" /> */}
            <div className="profile_text">
              <h6>Loading...</h6>
              <p>Please wait</p>
            </div>
          </div>
        </div>
      ) : count === 0 ? (
        /* NO TESTIMONIALS AVAILABLE */
        <div className="testimonial_box text-center">
          <i className="fa-solid fa-quote-left"></i>
          <p>No testimonials available at this time.</p>
          <div className="profile">
            <img src="images/testimonial_slider-img-1.png" alt="none" />
            <div className="profile_text">
              <h6>No Testimonials</h6>
              <p>Check back soon</p>
            </div>
          </div>
        </div>
      ) : (
        /* WE HAVE TESTIMONIALS — SHOW SLIDER */
 <Slider ref={testimonialSliderRef} {...testimonialSlider} className="testimonial_slider">
  {activeTestimonials.map((testimonial, index) => (
    <div key={testimonial._id || index}>
      <div className="testimonial_box">
        <i className="fa-solid fa-quote-left"></i>

        <div className="testimonial_content">
          <div className="rate">
            {[...Array(5)].map((_, i) => (
              <span
                key={i}
                className={`fa fa-star ${
                  i < (testimonial.rating || 5) ? "checked" : ""
                }`}
              ></span>
            ))}
          </div>

          <p className="testimonial-message">
            {testimonial.message || "No testimonial content available"}
          </p>
        </div>

        <div className="profile">
          {/* <img
            src={
              testimonial.image
                ? `${API_BASE_URL}${testimonial.image}`
                : "images/testimonial_slider-img-1.png"
            }
            alt={testimonial.name || "Client"}
            loading="lazy"
            decoding="async"
          /> */}
          <div className="profile_text">
            <h6>{testimonial.name || "Anonymous"}</h6>
            <p>{testimonial.profession}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</Slider>
      )}
    </div>
  </div>
</section>






    </>
  );
};

export default Home;
